"use strict";

define('rs/modals/finder/finder.controller',['require','exports','module','underscore','e3-modal','rs/modals/finder/finder.view'],function (require, exports, module) {
  var _ = require('underscore');
  var E3Modal = require('e3-modal');
  var FinderView = require('rs/modals/finder/finder.view');
  var FinderController = E3Modal.SectionController.extend({
    defaultTitle: 'Finder',
    idProperty: 'id',
    properties: ['items', 'loadAll', 'multiSelect', 'showFilter', 'ariaControls'],
    buttons: [{
      text: 'Cancel',
      icon: 'ban',
      dismiss: true
    }, {
      text: 'Save',
      icon: 'save',
      action: 'Save',
      color: 'primary',
      ariaControls: ''
    }],
    initialize: function initialize() {
      this._super.apply(this, arguments);
    },
    startListeners: function startListeners() {
      this.listenTo(this, 'change:items', this.refreshItemsOnView);
    },
    viewIsAvailable: function viewIsAvailable() {
      this.startListeners();
    },
    defaultProperties: function defaultProperties() {
      return _.defaults(this._super(), {
        items: [],
        loadAll: false,
        multiSelect: true,
        showFilter: true
      });
    },
    allowAdditionalItem: function allowAdditionalItem(item) {
      var multi = this.getMultiSelect(),
        items = this.getItems();
      if (multi || !multi && items.length < 1) {
        this.addSelectedItem(item);
        return true;
      } else {
        return false;
      }
    },
    addSelectedItem: function addSelectedItem(item) {
      var items = _.clone(this.getItems());
      items.push(item);
      this.setItems(items);
    },
    deleteSelectedItem: function deleteSelectedItem(id) {
      var items = _.clone(this.getItems());
      items.splice(index, 1);
      this.setItems(items);
    },
    refreshItemsOnView: function refreshItemsOnView() {
      this.getView().refreshItemsList();
    },
    generateDisplayName: function generateDisplayName(item) {
      return item.displayName || ' ';
    },
    getFilter: function getFilter() {
      return this.getView().getFilterValue();
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        filter: this.getShowFilter(),
        singleSelect: !this.getMultiSelect()
      };
    },
    requestSaveItems: function requestSaveItems() {
      var items = this.getItems();
      this.getModal().resolve(items);
    },
    refresh: function refresh() {
      return Promise.resolve();
    },
    sectionDidLoad: function sectionDidLoad() {
      this.resize();
      if (this.getShowFilter()) {
        this.getView().focusInput();
      }
    },
    sectionIsReady: function sectionIsReady() {
      return this.render();
    },
    setupView: function setupView() {
      this.setView(new FinderView());
    },
    resize: function resize() {
      this.getView().resize();
    }
  }, {
    create: function create(properties) {
      var setAriaControlsValue = function setAriaControlsValue(finderController) {
        var approveButton = _.findWhere(finderController.getButtons(), {
          action: 'Save'
        });
        if (approveButton) {
          approveButton.ariaControls = finderController.getAriaControls();
        }
      };
      var finderController;
      if (_.isArray(properties)) {
        properties = {
          items: properties
        };
      }
      finderController = new this(properties);
      if (finderController.getAriaControls()) {
        setAriaControlsValue(finderController);
      }
      return finderController;
    }
  });
  module.exports = FinderController;
});

